import LoggedInUser from './LoggedInUser';
import Helpers from './Helpers';

export function createUniversalCode(maxRedeems) {
  return fetch(Helpers.endpoint('/universal_referral_codes'), {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      max_redeems: maxRedeems,
      auth_token: LoggedInUser.getInfo().auth_token
    })
  }).then(response => response.json());
}
